export default {
  auth: {
    signUp: {
      title: "Créer un compte",
      email: "Adresse email",
      password: "Mot de passe",
      confirmPassword: "Confirmer mon mot de passe",
      submit: "S'inscrire",
      loading: "Inscription en cours...",
      alreadyHaveAccount: "Déjà inscrit ? Connectez-vous",
      confirmationSent: "Un email de confirmation a été envoyé",
    },
    login: {
      title: "Se connecter",
      email: "Adresse email",
      password: "Mot de passe",
      submit: "Se connecter",
      loading: "Connexion en cours...",
      forgotPassword: "Mot de passe oublié ?",
      noAccount: "Pas encore inscrit ? Créez un compte",
      language: "Langue",
    },
    forgotPassword: {
      title: "Mot de passe oublié",
      email: "Adresse email",
      submit: "Envoyer le lien de réinitialisation",
      loading: "Envoi en cours...",
      backToLogin: "Retour à la connexion",
      successMessage: "Un email de réinitialisation a été envoyé",
    },
    resetPassword: {
      title: "Réinitialiser mon mot de passe",
      password: "Nouveau mot de passe",
      confirmPassword: "Confirmer le nouveau mot de passe",
      submit: "Réinitialiser mon mot de passe",
      loading: "Réinitialisation en cours...",
      success:
        "Votre mot de passe a été réinitialisé avec succès ! Vous pouvez maintenant vous connecter.",
    },
    confirmEmail: {
      title: "Confirmation de l'email requise",
      verifying: "Verification en cours...",
      invalidLink: "Lien invalide",
      backToLogin: "Retour à la connexion",
      successMessage: "Votre compte a été activé",
    },
    errors: {
      generic: "Une erreur est survenue. Veuillez réessayer.",
      invalidEmail: "Email invalide",
      passwordRequired: "Le mot de passe est requis",
      passwordLength: "Le mot de passe doit contenir au moins 6 caractères",
      passwordFormat:
        "Le mot de passe doit contenir au moins une majuscule, une minuscule et un chiffre",
      passwordMatch: "Les mots de passe ne correspondent pas",
      noAdminAccess: "Accès non autorisé",
      invalidToken: "Lien invalide ou expiré",
      samePassword: "Le nouveau mot de passe doit être différent de l'ancien",
    },
  },
};
